var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineBannerIcBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1542_4630)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14286 9.28571C2.14286 5.34083 5.34083 2.14286 9.28571 2.14286C13.2306 2.14286 16.4286 5.34083 16.4286 9.28571C16.4286 13.2306 13.2306 16.4286 9.28571 16.4286C5.34083 16.4286 2.14286 13.2306 2.14286 9.28571ZM9.28571 0C4.15736 0 0 4.15736 0 9.28571C0 14.4141 4.15736 18.5714 9.28571 18.5714C11.3344 18.5714 13.2282 17.908 14.7639 16.7841L17.5616 19.5819C18.1196 20.1397 19.024 20.1397 19.5819 19.5819C20.1399 19.024 20.1399 18.1194 19.5819 17.5616L16.7841 14.7639C17.908 13.2282 18.5714 11.3344 18.5714 9.28571C18.5714 4.15736 14.4141 0 9.28571 0Z",
    fill: "#3073D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3774 5.5722C10.1097 4.39842 8.43507 4.40574 8.17763 5.58182L8.16774 5.62714L8.1484 5.7152C7.86358 6.99059 6.83793 7.96929 5.54956 8.19343C4.32463 8.40653 4.32463 10.165 5.54956 10.3781C6.84243 10.603 7.87074 11.5878 8.15136 12.8697L8.17763 12.9897C8.43507 14.1658 10.1096 14.1731 10.3774 12.9993L10.4093 12.8595C10.7006 11.5821 11.7303 10.6046 13.0211 10.3801C14.2482 10.1666 14.2482 8.40493 13.0211 8.19144C11.7372 7.96809 10.7115 6.9997 10.414 5.73236C10.4057 5.697 10.398 5.66317 10.3897 5.6264L10.3774 5.5722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1542_4630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineBannerIcBlue);
export default __webpack_public_path__ + "static/media/timeline-banner-ic-blue.8de245f4b7233445128dc3ae065a486c.svg";
export { ForwardRef as ReactComponent };